/**
 * Soft-dim Suspense fallback for the Fleet Dashboard route.
 *
 * Replaces the generic "Loading page…" `<LoadingState>` while the
 * lazy-imported `FleetDashboardPage` chunk is downloading. The dashboard
 * has its OWN in-page overlay that takes over once the component
 * mounts — this loader is the bridge between "route changed" and
 * "dashboard chrome painted."
 *
 * Visual contract: same `bg-surface/60` recipe as the in-page overlay
 * (semi-transparent surface tint, no `backdrop-blur` because blur
 * shimmers during the fade transition and reads as eye-straining on
 * a text-dense dashboard). No text, no spinner — the dispatcher's
 * perception is "the page is settling in," not "loading…"
 */
import React from "react";
import { useTranslation } from "react-i18next";

const DashboardGlassLoader: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div
      className="absolute inset-0 z-10 pointer-events-none bg-surface/60"
      aria-label={t("fleetDashboard.dashboardGlassLoader.aria")}
      role="status"
      data-testid="dashboard-glass-suspense"
    />
  );
};

export default DashboardGlassLoader;
